import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OmsServiceService } from '../services/oms-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddTestModalComponent } from '../modal-popups/add-test-modal/add-test-modal.component';
import { DeleteItemModalComponent } from '../modal-popups/delete-item-modal/delete-item-modal.component';
import { ConfirmModalComponent } from '../modal-popups/confirm-modal/confirm-modal.component';
import { ReimburseModalComponent } from '../modal-popups/reimburse-modal/reimburse-modal.component';
import { ItemsReassignModalComponent } from '../modal-popups/items-reassign-modal/items-reassign-modal.component';
import { ConstantsService } from '../services/constants.service';
//import { ReScheduleItemComponent } '../modal-popups/re-schedule-item/re-schedule-item.component';
import { ReScheduleItemComponent } from '../modal-popups/re-schedule-item/re-schedule-item.component';
//UploadReportComponent
//import { UploadReportComponent } from '../modal-popups/upload-report/upload-report.component';
import { SharedService } from '../../../../tools/src/lib/shared/shared.service'
import { configurton } from '../../../../l2-radiology/src/assets/data/configuration';
import { OrderCancelModelComponent } from '../modal-popups/order-cancel-model/order-cancel-model.component'
import { NgxSpinnerService } from "ngx-spinner";
//
import { UploadReportDataComponent } from '../modal-popups/upload-report-data/upload-report-data.component';
import { VerityOtpComponent } from '../modal-popups/verity-otp/verity-otp.component';
import { actionButtonConfiguration } from '../../../../l2-radiology/src/assets/data/actionButtonConfiguration';
import { PrescriptionUploadComponent } from '../modal-popups/prescription-upload/prescription-upload.component';
import { OrderRejectModalComponent } from '../modal-popups/order-reject-modal/order-reject-modal.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, FormControl, FormsModule, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { EconsultReassignModalComponent } from '../modal-popups/econsult-reassign-modal/econsult-reassign-modal.component';
import { GeneratePaymentLinkComponent } from '../modal-popups/generate-payment-link/generate-payment-link.component';

@Component({
  selector: 'app-reimbursement-details',
  templateUrl: './reimbursement-details.component.html',
  styleUrls: ['./reimbursement-details.component.scss']
})
export class ReimbursementDetailsComponent implements OnInit {

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private omsServiceService: OmsServiceService,
    private modalService: NgbModal,
    private constantsService: ConstantsService,
    private sharedService: SharedService,
    private SpinnerService: NgxSpinnerService,
    public ngbActiveModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private toastr: ToastrService
  ) { }

  id: number;
  transId: string;
  claimId: string;
  reimburseDetailsRes = {};
  reimburseStatusListRes = {};
  reimburseStatusListRess = {};
  reimburseRequest = {};
  reimburseResStatusList = [];

  isReimbursNew: boolean = false;
  isReimbursAssigned: boolean = false;
  isReimbursInreview: boolean = false;
  isReimbursRejected: boolean = false;
  isReimbursApproved: boolean = false;
  isReimbursPaymentPending: boolean = false;
  isReimbursPaid: boolean = false;
  isReimburStatusRejectCheck: boolean = false;
  isReimburStatusCheck: boolean = false;
  isReimbursCompleted: boolean = false;
  isReimbursRejectCompleted: boolean = false;

  role: string = "";
  configuraionData;
  actionButtonConfiguration;
  //configuration Data
  isOrderComplete: boolean = false;
  isUploadReport: boolean = false;
  isOtpVerifyLink: boolean = false;
  isPrescriptionLink: boolean = false;
  isReAssign: boolean = false;
  isAddItem: boolean = false;
  isDeleteItem: boolean = false;
  isConfirmScheduleDate: boolean = false;
  isReScheduleOrder: boolean = false;
  isViewPrescriptionLink: boolean = false;
  isSendPrescriptionLink: boolean = false;
  isViewReport: boolean = false;
  isOrderReject: boolean = false;
  isViewPaymentLink: boolean = false;
  isRendOtp: boolean = false;
  isSendOtp: boolean = false;
  fileDownloadDisable :Boolean =true;
  isPrescriptionUploadButton: Boolean = false;
  isUploadButtonReady: Boolean = false;
  labAvailableTimingsRes = {};
  uploadForm: FormGroup;
  documentType: string = "";
  roleBasedValue:any;
  status = new FormControl();
  statusList:[];
  showVendor: boolean;
  selectValue = "";
  getReimburseRes:any;

 public counts = [
    {
      "name": "New",
      // "imgUrl": "assets/img/eye.png"
      "imgUrl":"https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885_1280.jpg"
    },
    {
      "name": "Assigned",
      "imgUrl":"https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885_1280.jpg"
    },
    {
      "name": "In review",
      "imgUrl":"https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885_1280.jpg"
    },
    {
      "name": "Rejected",
      // "imgUrl": "assets/img/eye.png"
      "imgUrl":"https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885_1280.jpg"
    },
    {      
      "name": "Approved",
      "imgUrl":"https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885_1280.jpg"    
    },
    {
      "name": "payment release",
      "imgUrl":"https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885_1280.jpg"
    },
    {
      "name": "Paid",
      "imgUrl":"https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885_1280.jpg"
    }
  ];

  public orderStatus = "Approved"

  ngOnInit(): void {
    
    this.sharedService.setHideHeader(false);
    this.SpinnerService.show();
  // this.getReimburseRes = this.viewReimburseData;
    //console.log(configurton);
    // console.log("viewReimburse=" + JSON.stringify(this.getReimburseRes));
    this.actionButtonConfiguration = actionButtonConfiguration;
    this.sharedService.role.subscribe(role => {

      this.role = role;
      // this.role ="97";
      //console.log("role from order details=" + role);

    });
    this.role = localStorage.getItem("role");

    this._activatedRoute.params.subscribe(params => {
      this.transId = params["transId"];
      this.claimId = params["claimId"];

      // this.getOrderDataById(this.id);
      this.getReimburseByTransIdClaimId(this.transId,this.claimId);
    })

    this.uploadForm = this.formBuilder.group({
      profile: [''],
      documentType: [''],
    });

    this.getStatusList();

  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.uploadForm.get('profile').setValue(file);
    }
  }

  getReimburseByTransIdClaimId(trans,claim) {
    // this.getStatusList();
    this.SpinnerService.show();
    // this.reimburseRequest['tenantCode'] = '1000001';
    // this.reimburseRequest['orgCode'] = '100001';
    this.reimburseRequest['tenantCode'] = '1000248';
    this.reimburseRequest['orgCode'] = '100337';
    this.reimburseRequest["transactionId"] = trans;
    this.reimburseRequest["claimId"] = claim;
    this.omsServiceService.getReimburseDetails(this.reimburseRequest).subscribe(
      (res) => {
        if (res["status"] == 1) {

          this.reimburseDetailsRes = res["data"];

          // this.reimburseStatusListRes = res["data"][0]["statusList"];
          this.reimburseResStatusList= res["data"][0]["statusList"];
          this.reimburseStatusListRes = res["data"][0]["statusList"].filter(x => x.enabled == 1);
          this.reimburseStatusListRess = this.reimburseStatusListRes[0].statusCode;
          if(this.reimburseStatusListRess == 4){
            this.isReimburStatusRejectCheck = true;
            this.isReimburStatusCheck = false;
          }else {
            this.isReimburStatusCheck = true; 
            this.isReimburStatusRejectCheck = false;
          }
          console.log(`reimburseStatusListRes`, this.reimburseStatusListRes);
      //  console.log(`statusList`, this.statusList);  
          if (this.reimburseStatusListRess != "" && this.reimburseStatusListRess != undefined) {
          // let getLatestStatusObj = this.getLatestStatusData(this.statusList, this.reimburseStatusListRes);

          if(this.reimburseStatusListRess == 1){
            this.isReimbursNew = false;
            this.isReimbursAssigned = true;
            this.isReimbursRejected = true; 
          }else if(this.reimburseStatusListRess == 2){
            this.isReimbursAssigned = false;
            this.isReimbursInreview = true;
            this.isReimbursRejected = true; 
          }else if(this.reimburseStatusListRess == 3){
            this.isReimbursInreview = false; 
            this.isReimbursApproved = true;
            this.isReimbursRejected = true;            
          }else if(this.reimburseStatusListRess == 4){
            this.isReimbursRejected = false;
            this.isReimbursRejectCompleted = true; 
          }else if(this.reimburseStatusListRess == 5){
            this.isReimbursApproved = false;
            this.isReimbursPaymentPending = true;
            this.isReimbursRejected = false; 
          }else if(this.reimburseStatusListRess == 6){
            this.isReimbursPaymentPending = false;
            this.isReimbursPaid = true;
            this.isReimbursRejected = false; 
          }else if(this.reimburseStatusListRess == 7){  
            this.isReimbursPaid = false;          
            this.isReimbursRejected = false; 
            this.isReimbursCompleted = true;
          }
      // console.log(`reimburseStatusListRes`, this.reimburseStatusListRes);
      //  console.log(`getLatestStatusObj`, getLatestStatusObj);
          }else{
            this.isReimbursNew = true;
            this.isReimbursRejected = true; 
          }

          this.SpinnerService.hide();

        }
        this.SpinnerService.hide();
      }

    )
  }

    getLatestStatusData(listOfData, status) {
    let obj = {};
    for (let data of listOfData) {

      if (status.statusCode == data.statusCode) {
        obj = data.status;
      }

    }
    return obj;
  }

  getStatusList(){

    let statusRequest = {};
    // statusRequest["claimId"] = '12345';
    statusRequest["claimId"] = this.claimId;

    this.omsServiceService.getReimburseStatusList(statusRequest).subscribe(
      (res) => {
      this.statusList=res["data"]
      // this.diagnosticCenterList.push({ "code": data.code, name: data.name });
      }
    )
  }

  updateStatus(res){

    let statusRequest = {};
    statusRequest["claimId"] = this.claimId;
    statusRequest["claimStatus"] = +res;
    statusRequest["userId"] = window.localStorage.getItem('actionById');
    statusRequest["transactionId"] = this.transId;
// console.log(`claimStatus`, +this.status.value);
    this.omsServiceService.updateReimburseStatus(statusRequest).subscribe((res:any)=>{
      console.log(`res222222`, res);
      if(res.status == 1){
        this.toastr.success(res.message)
        // this.getOrderDataById(this.id)
        this.getReimburseByTransIdClaimId(this.transId,this.claimId);
      }else{
        this.toastr.error(res.message)
      }    
    })
  }

  openReimburseModal(type,obj) {      
    const modalRef = this.modalService.open(ReimburseModalComponent);
    const closeModelRef = modalRef.result.then(
      (res) => {
        this.getReimburseByTransIdClaimId(this.transId,this.claimId);

      }
    );
      modalRef.componentInstance.transId = this.transId;
      modalRef.componentInstance.claimId = this.claimId;
      modalRef.componentInstance.isReimburseType = type;
      modalRef.componentInstance.isReimburseObj = obj;
      modalRef.componentInstance.isDetailsResObj = this.reimburseDetailsRes;
  }
  
  CloseTab() {
    window.close();
  }

  download(id: any, type: number) {
    let downloadFileRequest = {};
    if (type == 1) {
      downloadFileRequest["doc_id"] = id;
    } else if (type == 2) {
      downloadFileRequest["doc_id"] = id;
    } else if (type == 3) {
      downloadFileRequest["doc_id"] = id;
    }

    this.omsServiceService.getDownloadDoc(downloadFileRequest).subscribe(
      (res: any) => {
        console.log(`res`, res);
        if (res["status"] == "SUCCESS") {
          window.open(res['dataObject'], '_blank');
        }
      }
    )
  }
  
}
